<template>
  <div id="body" class="is-2column" 
    :class="{'is-hidden-header' : targetScrollFlg}"
  >
  <BackgroundImage />
  <DocumentLink />

    <!-- menu:start -->
    <PCMenu
      class="visible"
      v-if="visibleMenu"
      :parentName="'PCQAList'"
      @searchByKeyword="group1.searchWithOptions({ from_menu: true, search_executed: true })"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->
    
    <!-- 並び順 -->
    <transition name="popup">
      <PCQASearchOrderSetting
        v-if="state.visibleSearchOrderSettings"
        @closeSearchOrderSettings="state.visibleSearchOrderSettings = false"
      />
    </transition>

    <!-- 表示設定 -->
    <transition name="popup">
      <PCQASearchDisplaySetting
        v-if="state.visibleSearchDisplaySettings"
        @closeSearchDisplaySettings="state.visibleSearchDisplaySettings = false"
      />
    </transition>

    <!-- ノートの選択（一覧画面用） -->
    <transition name="popup">
      <PCSelectNoteForList
        v-if="state.visibleSelectNote"
        :type="'qa'"
        :typeId="group1.targetQaIdToSelectNote"
        :startLoading="state.visibleSelectNote"
        @closeKnowledgeSelectNote="state.visibleSelectNote = false"
      />
    </transition>

    <div id="wrapper">
      <!-- header:start -->
      <PCSearchUI 
        :screenType="'qa'"
        :isAlertShown="false"
        :isSearchExecutedAtSameScreen="true"
        @search="group1.searchWithOptions"
        @searchDetail="group1.searchWithOptions"
      />
      <!-- header:end -->

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button" 
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !visibleMenu"
        >
        <IconMenu class="icn" 
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->

      <!-- content:start -->
      <div id="content">
        <div class="" id="navi">
          <div v-if="group1.isSearchDetail" class="navigation-title">検索結果</div>
          <div v-else class="navigation-title">絞り込み</div>
          <div class="navigation-list pb72"
            style="height:calc(100vh - 84px);"
            >

            <FontawesomeIcon v-if="!group1.isListPackagesAndProductsLoaded" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
            <template v-else>

              <p v-if="!group1.packagesAndProductsDataExists" class="txt pt20 pl20" style="color:white;">検索結果がありません。</p>
              <template v-else>
                <nav v-if="typeof group1.packagesAndProductsAreaTreeData.packages !== 'undefined' && group1.packagesAndProductsAreaTreeData.packages.length > 0" class="list01 bg-02 list-cb">
                  <PCPackageAndProductsTreeItem
                    :model="group1.packagesAndProductsAreaTreeData"
                    :isSearchCountShown="group1.isSearchCountShown"
                    :isSearchDetail="group1.isSearchDetail"
                    @emitItemClicked="group1.onPackageAndProductsTreeItemClicked"
                  />
                </nav>

                <nav v-if="group1.packagesAndProductsAreaBooks.length > 0" class="list01 bg-02 list-cb">
                  <ul>
                    <li v-for="(item, index) in group1.packagesAndProductsAreaBooks" :key="'single_books_' + index" class="list01-item is-parent is-open">
                      <div class="label">
                        <div class="formparts checkbox">
                          <input type="checkbox" 
                            v-model="group1.single_books" :value="item.product_id + ',' + item.book_id"
                            @change="group1.onSingleBookClicked"
                            :id="'package_product_books_' + item.id"
                          >
                          <label :for="'package_product_books_' + item.id"
                            >{{ item.name }} <template v-if="group1.isSearchCountShown">({{ item.search_count }})</template><FontawesomeIcon icon="check" class="icn" /></label>
                        </div>
                      </div>
                    </li>
                  </ul>
                </nav>
              </template>
            </template>

          </div>
        </div>
        <main class="" id="main">
          <div class="box02 white">

            <div class="box02-hdg">
              <h1 class="box02-hdg-title hdg03">検索結果</h1>
              <span v-if="group1.isTotalItemLoaded" class="box02-hdg-title-sup">{{ group1.totalItemsDisp }}件</span>
              <span v-if="group1.isSearchCountShown" @click="group1.searchResetOptions" class="box02-hdg-title-sup-link" role="button">検索をクリア</span>
              <div class="box02-hdg-aside">
                <span role="button" class="box02-hdg-aside-menu" 
                  @click="state.visibleSearchOrderSettings = true"
                >並び順の設定 - <template v-if="group1.isQAListSettingsLoaded">{{ group1.orderDisp }}</template></span>
                <span role="button" class="box02-hdg-aside-menu"
                  v-if="!isFromAdminSystem()"
                  @click="group1.onSaveSearchConditionClicked()"
                >検索条件の保存</span>
                <span role="button" class="box02-hdg-aside-menu" 
                  @click="state.visibleSearchDisplaySettings = true"
                >表示設定</span>
              </div>
            </div>

            <div class="box02-body"
              @scroll="handleScroll"
              style="height:calc(100vh - 108px);overflow-y:auto;"
              id="scroll-target"
            >
              <FontawesomeIcon v-if="!group1.isQAListLoaded" :icon="['fal','spinner-third']" size="2x" class="icn fa-spin" style="height:100%;" />
              <template v-else>
                <p v-if="!group1.listExists" class="txt pt32 pb32 pl40 pr40">キーワードに合致する検索結果がありませんでした。<br>検索キーワードを変更して再度検索してください。</p>
                <template v-else>

                  <PCPagenation
                    v-if="group1.isPaginationShown"
                    :count="group1.totalItems"
                    :per_page="group1.perPage"
                    :currentPage="group1.currentPage"
                    @changePage="group1.onPageChanged"
                  />

                  <ul class="list-result">
                    <li v-for="(item, index) in group1.list" :key="index" class="list-result-item" :id="'list-item-' + item.id">
                      <div class="list-result-item-main">
                        <div class="list-result-title"><a 
                        @click.stop.prevent="group1.onQATitleInListClicked(item.book_id, item.book_name, item.id)" 
                        role="button" v-html="item.title"></a></div>
                        <p v-show="!group1.is_hidden_text" v-html="item.text" class="list-result-text"></p>
                        <div class="list-result-note">
                          <span v-if="!group1.is_hidden_current && item.citation_date !== ''" 
                          class="list-result-sup">内容現在：{{ item.citation_date }}</span>
                          <span v-if="!isFromAdminSystem() && (!group1.is_hidden_note && item.note_count > 0)"
                            @click="group1.onNoteInListClicked(item.id)" 
                            class="list-result-link" role="button">ノート（{{ item.note_count }}）</span>
                          <a v-if="!group1.is_hidden_format && item.form_download_count > 0"
                            @click.stop.prevent="group1.onDocumentDownloadsInListClicked(item.book_id, item.book_name, item.id)" 
                            class="list-result-link" role="button">書式ダウンロード</a>
                        </div>
                        <a v-show="!group1.is_hidden_book"
                        @click.stop.prevent="group1.onBookInListClicked(item.book_id, item.book_name)" 
                        class="list-result-link pl0 pr0" role="button">{{ item.book_name }}</a>
                      </div>
                      <div class="list-result-item-sub">
                        <ButtonViewLater 
                          v-if="!isFromAdminSystem()"
                          :afterId="item.after_id"
                          :paramId="item.id"
                          :paramKey="'qa'"
                          :gaClass="'ga-qa-list-view-later'"
                          @onViewLaterChanged="group1.onViewLaterChanged"
                        />
                      </div>
                    </li>
                  </ul>

                  <PCPagenation class="mb40"
                    v-if="group1.isPaginationShown"
                    :count="group1.totalItems"
                    :per_page="group1.perPage"
                    :currentPage="group1.currentPage"
                    @changePage="group1.onPageChanged"
                  />

                </template>
              </template>

            </div>
          </div>
        </main>
      </div>
      <!-- content:end -->

      <span id="btnTop" @click="scrollAreaTop('#scroll-target')">TOP</span>
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive } from '@vue/composition-api'

import PCSearchUI from '@/components/pc/partial/PCSearchUI'
import PCMenu from '@/components/pc/popup/PCMenu.vue'
import PCQASearchDisplaySetting from '@/components/pc/popup/PCQASearchDisplaySetting.vue'
import PCQASearchOrderSetting from '@/components/pc/popup/PCQASearchOrderSetting.vue'
import PCSelectNoteForList from '@/components/pc/popup/PCSelectNoteForList.vue'
import PCBasicToast from '@/components/pc/popup/PCBasicToast.vue'
import PCPagenation from '@/components/pc/partial/PCPagenation.vue'
import ButtonViewLater from '@/components/pc/partial/ButtonViewLater.vue'

import PCPackageAndProductsTreeItem from '@/components/pc/partial/qa/PCPackageAndProductsTreeItem'
import * as logicQAList from '@/logic/qa/QAList'
import { isFromAdminSystem } from '@/util/common'

export default defineComponent({
  components: {
    PCSearchUI,
    PCMenu,
    PCQASearchDisplaySetting,
    PCQASearchOrderSetting,
    PCSelectNoteForList,
    PCBasicToast,
    PCPagenation,
    ButtonViewLater,
    PCPackageAndProductsTreeItem
  },  
  setup (props, context) {

    const { group1, state, searchSelect, clickSearchHistory } = logicQAList.getGroup(props, context)

    return {
      isFromAdminSystem,
      group1,
      state,
      searchSelect,
      clickSearchHistory
    }
  }
})
</script>

<style lang="scss" scoped>
  .box02-hdg-title {
    display: inline-block;
    vertical-align: middle;
  }
  .list-result {
    &-item {
      &-main {
      }
      &-sub {
      }
    }
  }
</style>
